import store from "@/store";

export function getPrincipalsWithAdZoneInAppdinxLogin(adZoneId) {
  const principals = store.state.principals;
  return principals.filter(principal => {
    const appdinxLogin = principal.additional_data?.appdinxLogin;
    if (!appdinxLogin?.advertising?.active) {
      return false;
    }

    const { text1, text2, text3 } = appdinxLogin.advertising.zones;
    return [text1, text2, text3].includes(adZoneId);
  });
}

export const AdvertisingZonePlacementOptions = {
  app: [
    { label: "Nach Textblock 1", value: "after_textblock1" },
    { label: "Nach Textblock 2", value: "after_textblock2" },
    { label: "Nach Textblock 3", value: "after_textblock3" }
  ],
  news_widget: [
    { label: "Detailansicht oben", value: "detail_top" },
    { label: "Detailansicht unten", value: "detail_bottom" },
    { label: "Nach Textblock 1", value: "after_textblock1" },
    { label: "Nach Textblock 2", value: "after_textblock2" },
    { label: "Nach Textblock 3", value: "after_textblock3" },
    { label: "Liste oben", value: "list_top" },
    { label: "Liste unten", value: "list_bottom" }
  ],
  pois_widget: [
    { label: "Detailansicht oben", value: "detail_top" },
    { label: "Detailansicht unten", value: "detail_bottom" },
    { label: "Liste oben", value: "list_top" },
    { label: "Liste unten", value: "list_bottom" }
  ],
  events_widget: [
    { label: "Detailansicht oben", value: "detail_top" },
    { label: "Detailansicht unten", value: "detail_bottom" },
    { label: "Liste oben", value: "list_top" },
    { label: "Liste unten", value: "list_bottom" }
  ]
};

export const AdvertisingZoneTargetOptions = [
  { label: "Website", value: "website" },
  { label: "App", value: "app" },
  { label: "EO.Heimat News-Widget", value: "news_widget" },
  { label: "EO.Heimat POIs-Widget", value: "pois_widget" },
  { label: "EO.Heimat Events-Widget", value: "events_widget" }
];

export function getAdZoneItemText(adZone) {
  const targetText =
    AdvertisingZoneTargetOptions.find(target => target.value === adZone.target)
      ?.label || "---";
  if (adZone.target === "website") {
    return `${adZone.name} (${targetText})`;
  }

  const placementText =
    AdvertisingZonePlacementOptions[adZone.target]?.find(
      placement => placement.value === adZone.placement
    )?.label || "---";
  return `${adZone.name} (${targetText}, ${placementText})`;
}
